<template>
	<div class="angkasa-report">
		<b-card no-body>
			<b-card-header class="py-2 px-3">
				<h3 class="mb-0">Angkasa Report</h3>
			</b-card-header>
			<div v-if="tableData.length > 0" class="rounded-bottom">
				<el-table :data="tableData" show-summary :summary-method="getTotal" sum-text="Total" style="width: 100%">
					<el-table-column label="Organization/Type" min-width="220" width="auto">
						<template slot-scope="scope">
							<p class="top-line text-break">{{ scope.row.aks_rep_itm_org_name }}</p>
							<p v-for="(detail, index) in scope.row.aks_rep_itm_details" :key="index"
								class="text-capitalize bottom-line text-break mb-0">{{ detail.aks_rep_itm_detail_type }}<br>
							</p>
						</template>
					</el-table-column>
					<el-table-column prop="aks_rep_itm_org_no" label="Code" min-width="120" width="auto">
						<template slot-scope="scope">
							<p class="top-line">{{ scope.row.aks_rep_itm_org_no }}</p>
						</template>
					</el-table-column>
					<el-table-column label="Acc. Type/Begin-End" min-width="220" width="auto">
						<template slot-scope="scope">
							<p class="top-line text-break">{{ scope.row.aks_rep_itm_org_status }}</p>
							<p v-for="(detail, index) in scope.row.aks_rep_itm_details" :key="index"
								class="text-capitalize bottom-line mb-0">{{ detail.aks_rep_itm_detail_begin }} - {{
									detail.aks_rep_itm_detail_end }}<br>
							</p>
						</template>
					</el-table-column>
					<el-table-column label="Total Amt./Deduction Amt. (RM)" width="160">
						<template slot-scope="scope">
							<p class="top-line text-break">{{ scope.row.aks_rep_itm_org_deduction_amount | moneyFormatter }}</p>
							<p v-for="(detail, index) in scope.row.aks_rep_itm_details" :key="index"
								class="text-capitalize bottom-line mb-0">{{ detail.aks_rep_itm_detail_deduction_amount | moneyFormatter
								}}<br>
							</p>
						</template>
					</el-table-column>
				</el-table>
			</div>
			<div v-else class="bg-light p-3 text-center rounded-bottom">
				<p class="text-xs">No Angkasa Report recorded</p>
			</div>
		</b-card>
	</div>
</template>
<script>
import { Table, TableColumn } from 'element-ui'

export default {
	name: 'angkasa-report',
	props: ['angkasa_report','angkasa_total'],
	components: {
		[Table.name]: Table,
		[TableColumn.name]: TableColumn,
	},
	data() {
		return {
			tableData: this.angkasa_report,
			total: this.angkasa_total
		}
	},
	methods: {
		getTotal() {
			const sums = [];
			sums[2] = 'Total'
			sums[3] = parseFloat(this.total).toLocaleString(undefined, { minimumFractionDigits: 2 });

			return sums;
		}
	}
}
</script>